import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "my-toolbar",
  style: {"height":"0","border":"none"}
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  id: "my-toolbar",
  style: {"height":"0","border":"none"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(this.title), 1),
    (this.enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (this.isOkToComment)
            ? (_openBlock(), _createBlock(_component_quill_editor, {
                key: 0,
                ref: "editor",
                options: this.options,
                toolbar: this.toolbar,
                content: this.commentData,
                contentType: "html"
              }, null, 8, ["options", "toolbar", "content"]))
            : (_openBlock(), _createBlock(_component_quill_editor, {
                key: 1,
                ref: "editor",
                options: [],
                toolbar: "#my-toolbar",
                "read-only": true,
                content: this.commentData,
                contentType: "html",
                style: {"min-height":"86px"}
              }, null, 8, ["content"])),
          _hoisted_3,
          (this.enabled)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                class: "my-auto d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  (!this.isOkToComment)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "auto",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            density: "comfortable",
                            rounded: "xs",
                            onClick: _ctx.addComment
                          }, {
                            default: _withCtx(() => [
                              (this.commentData === '')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Ajouter un commentaire"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, "Modifier le commentaire"))
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (this.isOkToComment)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 1,
                        cols: "auto",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "warning",
                            density: "comfortable",
                            rounded: "xs",
                            onClick: _ctx.saveComment
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Valider")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (this.isOkToComment)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 2,
                        cols: "auto",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            color: "secondary",
                            density: "comfortable",
                            rounded: "xs",
                            onClick: _ctx.cancelComment
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Annuler")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_quill_editor, {
            ref: "editor",
            options: [],
            toolbar: "#my-toolbar",
            "read-only": true,
            content: this.commentData,
            contentType: "html",
            style: {"min-height":"86px"}
          }, null, 8, ["content"]),
          _hoisted_7
        ]))
  ], 64))
}